import React from "react";
import { Image } from "semantic-ui-react";
import ExIcon from "../../assets/images/error.png";

export const getErrorComponent = (errMsg, actCharge, actType, actPrice) => {
  let ignoreAdditionalMessage = false;
  if (actCharge === "f" && actType === "People_Ssnverify")
    ignoreAdditionalMessage = true;
  let additionalMessage = "Your account has NOT been charged for this search.";
  if (actCharge === "b")
    additionalMessage = `Your account has been charged ${actPrice} for this search.`;
  return (
    <div>
      <div className={"error-message-box red-text text-center"}>
        <Image src={ExIcon} inline className={"icon-align-middle"} />{" "}
        <b>{errMsg}</b>
        <br />
        {!ignoreAdditionalMessage && (
          <span style={{ color: "black" }}>{additionalMessage}</span>
        )}
      </div>
    </div>
  );
};

export default getErrorComponent;



// WEBPACK FOOTER //
// ./src/components/messages/ErrorComponent.js